import { useQuery } from '@tanstack/react-query';
import { supabase } from '../integrations/supabase/client';

export interface Stats {
  total_rides: number;
  happy_clients: number;
  years_experience: number;
  fleet_size: number;
}

export const useStats = () => {
  return useQuery({
    queryKey: ['stats'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('stats')
        .select('metric_name, metric_value');
      
      if (error) throw error;
      
      const stats: Stats = {
        total_rides: 0,
        happy_clients: 0,
        years_experience: 0,
        fleet_size: 0,
      };
      
      data?.forEach((stat: { metric_name: string; metric_value: number }) => {
        if (stat.metric_name in stats) {
          stats[stat.metric_name as keyof Stats] = stat.metric_value;
        }
      });
      
      return stats;
    },
  });
};
